<h3 *ngIf="data && data.title">{{data.title}}</h3>
<p *ngIf="data && data.body">{{data.body}}</p>
<div class="dialog-actions">
  <button type="button" class="button-primary button-confirm" (click)="dialogRef.close(true)" cdkFocusInitial translate>GENERAL.CONFIRM</button>
  <button type="button" class="button-primary" (click)="dialogRef.close(false)" translate>GENERAL.CANCEL</button>
</div>